(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kx-product-type-rows"] && !Shopify.designMode) return;
  try {
    
/* AMAZON_ROW_PAGINATION_20260810 */
(function () {
  /* KX_ROW_IMAGE_DECODE_PRIME_20260811
     Prime/decode Collection Row images shortly before the row reaches
     the viewport. This prevents Chrome lazy-load/overflow partial paints
     without eagerly loading the entire homepage at once. */
  function primeKxRowImages(scope) {
    var blocks = scope.querySelectorAll('.kx-v2-type-row-block');

    function primeBlock(block) {
      block.querySelectorAll('.kx-v2-shelf-card__image img').forEach(function (img) {
        if (img.dataset.kxImagePrimed === '1') return;

        img.dataset.kxImagePrimed = '1';
        img.loading = 'eager';
        img.decoding = 'sync';

        if (typeof img.decode === 'function') {
          img.decode().catch(function () {
            /* Browser will fall back to its normal image decode path. */
          });
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      blocks.forEach(primeBlock);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        primeBlock(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '600px 0px',
      threshold: 0.01
    });

    blocks.forEach(function (block) {
      if (block.dataset.kxImagePrimeObserved === '1') return;

      block.dataset.kxImagePrimeObserved = '1';
      observer.observe(block);
    });
  }

  function initKxRows(root) {
    var scope = root || document;

    primeKxRowImages(scope);

    scope.querySelectorAll('.kx-v2-row-scroll-shell').forEach(function (shell) {
      var row = shell.querySelector('[data-kx-row-scroll]');
      var prev = shell.querySelector('.kx-v2-row-arrow--prev');
      var next = shell.querySelector('.kx-v2-row-arrow--next');
      var block = shell.closest('.kx-v2-type-row-block');
      var counter = block ? block.querySelector('[data-kx-page-counter]') : null;

      if (!row || !prev || !next) return;

      function getCards() {
        return Array.prototype.filter.call(row.children, function (el) {
          return el.classList && el.classList.contains('kx-v2-shelf-card');
        });
      }

      function getMetrics() {
        var cards = getCards();

        if (!cards.length) {
          return {
            cards: cards,
            perPage: 1,
            totalPages: 1,
            step: row.clientWidth
          };
        }

        var rowStyle = window.getComputedStyle(row);
        var gap = parseFloat(rowStyle.columnGap || rowStyle.gap || '0') || 0;
        var cardWidth = cards[0].getBoundingClientRect().width;

        var perPage = Math.max(
          1,
          Math.floor((row.clientWidth + gap + 1) / (cardWidth + gap))
        );

        var totalPages = Math.max(1, Math.ceil(cards.length / perPage));
        var step = perPage * (cardWidth + gap);

        return {
          cards: cards,
          perPage: perPage,
          totalPages: totalPages,
          step: step
        };
      }

      function getCurrentPage(metrics) {
        if (metrics.totalPages <= 1) return 1;

        var maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);

        if (row.scrollLeft >= maxScroll - 4) {
          return metrics.totalPages;
        }

        return Math.min(
          metrics.totalPages,
          Math.max(
            1,
            Math.floor((row.scrollLeft + metrics.step * 0.45) / metrics.step) + 1
          )
        );
      }

      function updateRow() {
        var metrics = getMetrics();
        var currentPage = getCurrentPage(metrics);

        if (counter) {
          counter.textContent = 'Page ' + currentPage + ' of ' + metrics.totalPages;
        }

        prev.hidden = metrics.totalPages <= 1 || currentPage <= 1;
        next.hidden = metrics.totalPages <= 1 || currentPage >= metrics.totalPages;
      }

      function goToPage(direction) {
        var metrics = getMetrics();
        var currentPage = getCurrentPage(metrics);
        var targetPage = Math.min(
          metrics.totalPages,
          Math.max(1, currentPage + direction)
        );

        var targetIndex = Math.min(
          metrics.cards.length - 1,
          (targetPage - 1) * metrics.perPage
        );

        var maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
        var targetLeft = 0;

        if (targetIndex > 0 && metrics.cards[targetIndex]) {
          targetLeft =
            metrics.cards[targetIndex].offsetLeft -
            metrics.cards[0].offsetLeft;
        }

        if (targetPage === metrics.totalPages) {
          targetLeft = Math.min(targetLeft, maxScroll);
        }

        row.scrollTo({
          left: Math.max(0, Math.min(targetLeft, maxScroll)),
          behavior: 'smooth'
        });
      }

      if (shell.dataset.kxPaginationReady !== '1') {
        prev.addEventListener('click', function () {
          goToPage(-1);
        });

        next.addEventListener('click', function () {
          goToPage(1);
        });

        var ticking = false;

        row.addEventListener('scroll', function () {
          if (!ticking) {
            window.requestAnimationFrame(function () {
              updateRow();
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });

        if ('ResizeObserver' in window) {
          new ResizeObserver(function () {
            updateRow();
          }).observe(row);
        } else {
          window.addEventListener('resize', updateRow);
        }

        shell.dataset.kxPaginationReady = '1';
      }

      window.requestAnimationFrame(updateRow);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initKxRows(document);
    });
  } else {
    initKxRows(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initKxRows(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
